<template>
  <div class="main-container" v-if="user == null || user == undefined">
    <router-view></router-view>
    <!-- Navbar section -->
    <HeaderStartup />
    <HeroStartup />
    <!-- service area  -->
    <CurveShape class="no-height">
      <template v-slot:bgcolor>
        <path
          style="fill: #ffffff;
                    stroke-miterlimit:10;"
          d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"
        />
      </template>
    </CurveShape>
    <div
      class="start-ups-feature startup-about-feature section-space--pt_120 section-space--pb_60 "
      id="about"
    >
      <div class="container">
        <div class="section-title-wrapper text-center section-space--mb_60">
          <h2 class="section-title mb-30 wow move-up">
            We provide valuable automation for every stage of any
            <span style="text-decoration: underline;">insurance claim</span> or
            <span style="text-decoration: underline;">civil dispute</span> in
            litigation.
          </h2>
          <v-btn class="video-button-container video-popup ">
            <silentbox-single src="https://youtu.be/37x0IbPaY1w">
              <div class="video-play">
                <i class="fa fa-play-circle"></i>
                <span class="video-text">INTRO & DEMO VIDEO</span>
              </div>
            </silentbox-single>
          </v-btn>
        </div>
        <!-- feature component -->
        <StartUpFeatureTwo />
      </div>
    </div>

    <!-- start up feature -->
    <div class="start-ups-feature" id="platform">
      <div class="container">
        <div class="section-title text-center section-space--mb_60">
          <h2 class="font-weight--bold mb-15 wow move-up">
            We Service Law Firms, Clients and Litigation Service Providers With
            a Single Platform
          </h2>
          <span class="section-text wow move-up"
            >We make life easier for everyone involved in the process</span
          >
        </div>
        <!-- start up feature component -->
        <StartUpFeature />
      </div>
    </div>

    <!-- call to action
    <div class="ht-start-up-section-bg">
      <div class="cta-image-area_one section-space--pt_60">
        <CtaOne />
      </div>
    </div> -->

    <!-- tab conetent section -->
    <!-- <div
      class="tabs-wrapper startup-tab section-space--mt_30 section-space--pb_120"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="section-title-wrapper text-center section-space--mb_60 wow move-up"
            >
              <h2 class="section-title font-weight--bold mb-15">
                We design powerful websites for <br />
                landing your success.
              </h2>
            </div>
          </div>
        </div> -->
    <!-- tab components -->
    <!-- <TabOne />
      </div>
    </div> -->

    <!-- team component -->
    <!-- <div
      class="team-member-wrapper section-space--ptb_120 default-bg"
      id="team"
    >
      <div class="container">
        <TeamTwo />
      </div>
    </div> -->

    <!-- tab conetent section -->
    <!-- <TabThree /> -->

    <!-- brand carousel -->
    <!-- <CarouselStartup /> -->

    <!-- contact form section -->
    <!-- <ContactForm /> -->

    <!-- call to action  -->
    <!-- <CtaFour /> -->
    <!-- footer section -->
    <!-- <FooterMain FooterStyle="bg_drak-footer" /> -->

    <!-- EARLY VERSION -->

    <!-- <v-flex
      v-if="userIsAuthenticated"
      style="background-color: #7894AC; box-shadow: 0 0 48px 48px #d8e2eb inset"
      flat
    >
      <v-img
        :src="require('../assets/tlLogo.svg')"
        class="my-3"
        contain
        height="200"
      ></v-img>
    </v-flex>
    <v-parallax
      :src="require('../assets/home.png')"
      v-if="!userIsAuthenticated"
    >
      <v-flex v-if="!userIsAuthenticated">
        <v-img
          :src="require('../assets/tlLogo.svg')"
          class="my-3"
          contain
          height="200"
        ></v-img>
      </v-flex>
      <v-flex mb-4>

        <v-card
          class="ma-auto text-center"
          style="background-color: transparent;"
          flat
        >
          <v-card-text class="display-1" v-if="userIsAuthenticated"
            >WELCOME</v-card-text
          >
          <div v-if="userIsAuthenticated" class="title font-weight-light">
            {{ user.fullName }}
          </div>
       
          <div v-if="firmIsLoaded" class="title font-weight-light">
            {{ firm.firmName }}
          </div>
        </v-card>
        <div v-if="mattersAreLoaded">
          
        </div>
      </v-flex>
    </v-parallax>

    <v-flex>
      <v-card
        style="background-color: transparent; max-width: 700px; height: 50vh; overflow: scroll"
        class="ma-auto text-center white--text font-weight-light"
        outlined
        shaped
        v-if="userIsAuthenticated"
      >
        <v-card-text class="display-2">ACTIVITIES</v-card-text>

       
        <div
          class="subtitle-1 white--text font-weight-light text-justify ml-2"
          style="border-radius: 26px;"
          v-for="(activity, index) in reversedActivities"
          :key="index"
        >
          <v-card
            style="background-color: transparent; max-width: 90%;"
            class="ma-auto mb-2"
            outlined
            shaped
          >
            <v-card-text>{{ activity.content }}</v-card-text>
            <v-card-actions>
              <v-btn small text color="green" @click="goToMatter(activity)"
                >GO</v-btn
              >
              <v-btn small text color="red" @click="deleteActivity(activity)"
                >DELETE</v-btn
              >
            </v-card-actions>
          </v-card>
        </div>
      </v-card>
    </v-flex> -->

    <!-- EARLY VERSION END  -->

    <!-- <v-flex mb-4></v-flex>
      <div v-if="user">
        <v-card>
          <v-card-title>USER:</v-card-title>
          <v-card-text>{{user}}</v-card-text>
        </v-card>
      </div>
      <div v-if="firm">
        <v-card>
          <v-card-title>FIRM:</v-card-title>
          <v-card-text>{{firm}}</v-card-text>
        </v-card>
      </div>
      <div v-if="matters.length > 0">
        <v-card>
          <v-card-title>MATTERS:</v-card-title>
          <div v-for="(matter, index) in matters" :key="index"></div>
          <v-card-text>{{matter}}</v-card-text>
        </v-card>
      </div>
      <v-flex mb-5 xs12></v-flex>

      <v-flex xs12 mb-5></v-flex>

      <v-flex xs12 mb-5></v-flex>-->
    <!-- </v-layout> -->

    <!-- </v-container> -->
    
  </div>
</template>

<script>
/**
 *
 * this is the home page
 *
 */

// import firebase from "firebase";
// import * as firebase from "firebase";
import HeaderStartup from "../components/HeaderStartup";
import HeroStartup from "../components/HeroStartup";
import CurveShape from "../components/CurveShape";
import StartUpFeatureTwo from "../components/StartUpFeatureTwo";
import StartUpFeature from "../components/StartUpFeature";
// import CtaOne from "../components/CtaOne";
// import TabOne from "../components/TabOne";
// import TeamTwo from "../components/TeamTwo";
// import TabThree from "../components/TabThree";
// import CarouselStartup from "../components/CarouselStartup";
// import ContactForm from "../components/ContactForm";
// import CtaFour from "../components/CtaFour";
// import FooterMain from "../components/FooterMain";
export default {
  components: {
    HeaderStartup,
    HeroStartup,
    CurveShape,
    StartUpFeatureTwo,
    StartUpFeature
    // CtaOne,
    // TabOne,
    // TeamTwo,
    // TabThree,
    // CarouselStartup,
    // ContactForm,
    // CtaFour,
    // FooterMain
  },
  data: () => ({
    //
    // user,
    // firm,
    reversedActivities: [],
    letterhead: null,
    canvasDialog: false,
    canvasSource: null,
    viewActivities: false
  }),
  methods: {
    deleteActivity(activity) {
      console.log(activity);
    },
    goToMatter(activity) {
      console.log(activity.matterID);
      let id = activity.matterID;
      this.$router.push({ name: "Matter", params: { id } });
    }
    // onFilePicked() {
    //   if (event.target.files) {
    //     this.canvasDialog = true;
    //     const fileList = Array.from(event.target.files);
    //     fileList.forEach(file => {
    //       console.log(file);
    //       this.letterhead = file;
    //       let reader = new FileReader();
    //       reader.readAsDataURL(file);
    //       reader.onloadend = function() {
    //         let image = new Image();
    //         image.src = reader.result;
    //         image.onload = () => {
    //           let canvas = document.getElementById("temp-canvas");
    //           canvas.width = image.width;
    //           canvas.height = image.height;
    //           let ctx = canvas.getContext("2d");
    //           ctx.drawImage(image, 0, 0);
    //         };
    //       };
    //     });
    //   }
    // },
    // saveLetterhead() {
    //   if (this.letterhead !== null && this.letterhead !== undefined) {
    //     this.canvasDialog = true;
    //     console.log("lettehead", this.letterhead);
    //     console.log("firm: ", this.firm);

    //     let letterHeadRef = firebase
    //       .storage()
    //       .ref(`/firms/${this.user.firmSlug}/letterhead.png`);
    //     letterHeadRef
    //       .put(this.letterhead)
    //       .then(() => {
    //         console.log("letterhead saved");
    //         letterHeadRef
    //           .getDownloadURL()
    //           .then(url => {
    //             let letterhead = {
    //               url: url,
    //               name: this.letterhead.name
    //             };
    //             firebase
    //               .firestore()
    //               .collection("matters")
    //               .doc(this.matter.matterSlug)
    //               .collection("letterhead")
    //               .update({ letterhead: letterhead })
    //               .then(() => {
    //                 (async () => {
    //                   let canvas = document.getElementById("temp-canvas");
    //                   const base64Canvas = await canvas.toDataURL("image/png");
    //                   firebase
    //                     .firestore()
    //                     .collection("matters")
    //                     .doc(this.matter.matterSlug)
    //                     .update({ letterheadData: base64Canvas });
    //                   await this.$refs.fileInput.clear;
    //                   this.canvasDialog = false;
    //                   canvas.src = "";
    //                 })();
    //               })
    //               .catch(e => {
    //                 console.error(e);
    //               });
    //           })
    //           .catch(e => {
    //             console.error(e);
    //           });
    //       })
    //       .catch(e => {
    //         console.error(e);
    //       });
    //   }
    // }
    // addClients() {
    //   //get each matter from the firm
    //   firebase
    //     .firestore()
    //     .collection("firms")
    //     .doc(this.firm.firmSlug)
    //     .collection("matters")
    //     .get()
    //     .then(matters => {
    //       matters.forEach(matter => {
    //         let matterData = matter.data();
    //         console.log(matterData.matterSlug);
    //         firebase
    //           .firestore()
    //           .collection("firms")
    //           .doc(this.firm.firmSlug)
    //           .collection("matters")
    //           .doc(matterData.matterSlug)
    //           .collection("clients")
    //           .get()
    //           .then(clients => {
    //             clients.forEach(client => {
    //               let clientData = client.data();
    //               console.log(clientData.clientSlug);
    //               firebase
    //                 .firestore()
    //                 .collection("firms")
    //                 .doc(this.firm.firmSlug)
    //                 .collection("matters")
    //                 .doc(matterData.matterSlug)
    //                 .collection("clients")
    //                 .doc(clientData.clientSlug)
    //                 .collection("formList")
    //                 .get()
    //                 .then(formList => {
    //                   formList.forEach(form => {
    //                     let formData = form.data();
    //                     firebase
    //                       .firestore()
    //                       .collection("matters")
    //                       .doc(formData.matterSlug)
    //                       .collection("clients")
    //                       .doc(formData.partySlug)
    //                       .collection("formList")
    //                       .doc(formData.id)
    //                       .set(formData);
    //                   });
    //                 })
    //                 .catch(e => {
    //                   console.error(e);
    //                 });
    //               // .set(clientData)
    //             });
    //           })
    //           .catch(e => {
    //             console.error(e);
    //           });
    //       });
    //     })
    //     .catch(e => {
    //       console.error(e);
    //     });
    //   //for each matter check if there's a client collection
    //   //add the client to the same matter in the root collection
    // }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    role() {
      return this.$store.getters.role;
    },
    userIsAuthenticated() {
      return (
        this.$store.getters.user !== null &&
        this.$store.getters.user !== undefined
      );
    },
    firm() {
      return this.$store.getters.firm;
    },
    firmIsLoaded() {
      return (
        this.$store.getters.firm !== null &&
        this.$store.getters.firm !== undefined
      );
    },
    matters() {
      return this.$store.getters.matters;
    },
    mattersAreLoaded() {
      return (
        this.$store.getters.matters !== null &&
        this.$store.getters.matters !== undefined
      );
    }
    // reversedActivities() {
    //   if (this.firm.actvities) {
    //     return this.firm.actvities.slice().reverse();
    //   } else {
    //     return null;
    //   }
    // }
  },

  watch: {
    user(value) {
      if (value !== null && value !== undefined) {
        // console.log("user from watch", value);
        // this.$store.dispatch("loadMatters", value);
        // this.$router.push('/');
        this.$store.dispatch("getFirm", this.user.firmSlug);
      }
    },
    firm(value) {
      if (value == null || value == undefined) {
        console.log("getting firm", value);

        this.$store.dispatch("getFirm", this.user.firmSlug);
      }
      if (value !== null && value !== undefined) {
        console.log("firm from watch", value);
        let payload = {
          firmSlug: this.firm.firmSlug,
          user: this.user.email
        };
        console.log("firing getMatters", payload);

        this.$store.dispatch("getMatters", payload);
        if (value.activities) {
          this.reversedActivities = value.activities.reverse();
          // console.log(
          //   "firm has activities from watch at home",
          //   value.activities
          // );
        }
        // this.$store.dispatch("getMatters", this.firm.firmSlug);
      }
    },
    matters(value) {
      if (value !== null && value !== undefined) {
        // console.log("matters from watch", value);
      }
    }
  },
  created() {
    //   console.log("hello from created at hello world");
    //   console.log("user: ", this.user);
    //   console.log("firm: ", this.firm);
    //   // console.log("matters: ", this.matters);
    //   let userFromCreated = this.$store.getters.user;
    //   console.log("userFromCreated", userFromCreated);

    //   let firmFromCreated = this.$store.getters.firm;
    //   console.log("firmFromCreated", firmFromCreated);

    // let data = {
    //   firm: this.firm,
    //   user: this.user
    // };

    // this.$store.dispatch("loadMatters", data);
    // this.$store.dispatch("loadMatters");
    if (this.user) {
      this.$store.dispatch("getFirm", this.user.firmSlug);
    }
  }
};
</script>
